import BlueRedOrange from './blue-red-orange.es.js';
import BlueVioletRed from './blue-violet-red.es.js';
import GreenBlueViolet from './green-blue-violet.es.js';
import OrangeVioletBlue from './orange-violet-blue.es.js';
import PurpleVioletRed from './purple-violet-red.es.js';
import RedOrangeGreen from './red-orange-green.es.js';

var fadeBottom = {
    GreenBlueViolet,
    BlueVioletRed,
    BlueRedOrange,
    PurpleVioletRed,
    OrangeVioletBlue,
    RedOrangeGreen
};

export { fadeBottom as default };
//# sourceMappingURL=index.es.js.map
